import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/_index';
import { AppConfigService } from '../../app-config.service';
import { Observable } from 'rxjs';
import { NotificationModele } from '../modeles/notification.modele';

@Injectable({
  providedIn: 'root'
})
export class NotificationsApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  private getApiUrl(): string {
    const idProjet = this._appConfigService.configData ? this._appConfigService.idProjet : null;
    return `/api/v1/projets/${idProjet}/notifications`;
  }

  private getApiUrlMassNotification(): string {
    const idProjet = this._appConfigService.configData ? this._appConfigService.idProjet : null;
    return `/api/v1/projets/${idProjet}/massnotifications`;
  }

  getNotifications(): Observable<NotificationModele[]> {
    return this._bffApiService.getJSONBFF(this.getApiUrl()) as Observable<NotificationModele[]>;
  }

  deleteNotification(idNotification: string): Observable<NotificationModele> {
    return this._bffApiService.deleteBFF(`${this.getApiUrl()}/${idNotification}`) as Observable<NotificationModele>;
  }

  deleteMassNotification(idNotification: string): Observable<NotificationModele> {
    return this._bffApiService.putJSONBFF(`${this.getApiUrlMassNotification()}/${idNotification}`) as Observable<
      NotificationModele
    >;
  }
}
